const stats = [
  { value: '99.9%', label: 'App Uptime Reliability' },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left – Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden h-[480px]">
              <img
                src="https://public.readdy.ai/ai/img_res/c9d81883610508dbab92866d9c5084e8.jpg"
                alt="ALFA DOO team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            {/* Floating stat card */}
            <div className="absolute -bottom-6 -right-4 md:right-0 bg-white rounded-2xl p-5 border border-gray-100 w-52">
              <div className="flex items-center gap-3 mb-1">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-500">
                  <i className="ri-apple-line text-white text-sm" />
                </div>
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Platform</span>
              </div>
              <p className="text-gray-900 font-bold text-sm">iOS Specialists</p>
              <p className="text-gray-400 text-xs mt-0.5">iPhone &amp; iPad native apps</p>
            </div>
          </div>

          {/* Right – Content */}
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-600 mb-3 block">Who We Are</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
              A Team Passionate<br />About iOS Innovation
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              ALFA DOO is a dedicated team of iOS engineers, designers, and security experts united by a single mission: to build applications that genuinely improve people&apos;s digital lives. We specialize in creating tools that are powerful under the hood yet effortless to use.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-10">
              From our VPN solution that guards your privacy to our Cleaner app that keeps your device running at peak performance, every product we ship reflects our obsession with quality, security, and user experience.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, idx) => (
                <div key={idx} className="border-l-2 border-emerald-500 pl-4">
                  <p className="text-3xl font-extrabold text-gray-900">{stat.value}</p>
                  <p className="text-sm text-gray-500 mt-0.5">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
